<template>
  <modal :showCloseIcon="true" @close="exit" @escape="exit" class="message-notifier">
    <div v-if="title" slot="header" class="margin-bottom-x2 title">{{title}}</div>
    <div v-if="message" slot="body">
      <div class="desc margin-bottom-x2 padding">{{message}}</div>
      <div>
        <ttw-button _class="light-black-bg" @click="exit" value="Close" />
      </div>
    </div>
  </modal>
</template>
<script>
import Modal from "@/components/layout/Modal";
export default {
  inheritAttrs: false,
  name: "message-notifier",
  extends: Modal,
  components: {
    Modal
  },
  props: {
    title: {
      type: String,
      default: "Notice"
    },
    message: String
  },
  methods: {
    exit() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
.message-notifier {
  .title {
    color: $orange;
    font-size: 1.25rem;
  }
  .desc {
    line-height: 2;
  }
}
</style>